import { Box } from "@mui/material";
import Ghost from "./ghost";
import GhostListProps from "@/app/interfaces/props/GhostListProps";

const GhostList = ({ count = 1, ghostHeight = 200 }: GhostListProps) => {
  const ghosts = Array.from({ length: count });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {ghosts.map((_, index) => (
        <Ghost key={index} height={ghostHeight} />
      ))}
    </Box>
  );
};

export default GhostList;
